import { render } from "./SelectLanguageForm.vue?vue&type=template&id=19cf2db4&scoped=true"
import script from "./SelectLanguageForm.vue?vue&type=script&lang=js"
export * from "./SelectLanguageForm.vue?vue&type=script&lang=js"

import "./SelectLanguageForm.vue?vue&type=style&index=0&id=19cf2db4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19cf2db4"]])

export default __exports__